import { Tooltip } from "@mui/material";

interface RenderLabelWithTooltipProps {
  label: any;
  maxLength?: number;
}

const RenderLabelWithTooltip = ({
  label,
  maxLength = 20,
}: RenderLabelWithTooltipProps) => {
  const text = String(label ?? "");
  const shouldTruncate = text.length > maxLength;
  const displayText = shouldTruncate ? `${text.slice(0, maxLength)}...` : text;

  return shouldTruncate ? (
    <Tooltip title={text} placement="top">
      <span>{displayText}</span>
    </Tooltip>
  ) : (
    <span>{displayText}</span>
  );
};

export default RenderLabelWithTooltip;
